import $ from 'jquery';
import API from '../endpoints.json';

const AUTH_SUCCESS = 'auth:success';
const authSuccess = () => {
    return {
        type: AUTH_SUCCESS,
        payload: null,
    }
}

const AUTH_FAIL = 'auth:fail';
const authFail = (error) => {
    return {
        type: AUTH_FAIL,
        payload: error,
    }
}

const SET_USER = 'set:user';
const _setUser = user => {
    return {
        type: SET_USER,
        payload: user,
    }
}

const setUser = _ => {
    return dispatch => $.get(API.USER, {
    }).done((data, textStatus, jqXHR) => {
        dispatch(_setUser(data));
    }).fail((jqXHR, status, error) => {
        dispatch(authFail('Unable to fetch logged in user details.'))
    })
}

const login = (username, password) => {
    return dispatch => $.post(API.LOGIN, {
        username, password,
    }).done((data, textStatus, jqXHR) => {
        localStorage.setItem('effToken', jqXHR.getResponseHeader('token'));
        dispatch(authSuccess());
    }).fail((jqXHR, status, error) => {
        dispatch(authFail(jqXHR.responseText || error));
    });
}

const getSignature = username =>
    dispatch => $.get(API.SIGNATURE, { username });


const AUTH_LOGOUT = 'auth:logout'
const logout = _ => {
    localStorage.removeItem('effToken');
    return {
        type: AUTH_LOGOUT,
        payload: null,
    }
}

export {
    AUTH_SUCCESS,
    AUTH_FAIL,
    SET_USER,
    AUTH_LOGOUT,
    login,
    getSignature,
    setUser,
    logout,
};
